import { projectUserRoleSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';
import { useUser } from './useUser';

const responseSchema = z.object({
  role: projectUserRoleSchema,
});

interface Params {
  projectId: string;
  noRetry?: boolean;
}

export function useUserProjectRole({ projectId, noRetry = false }: Params) {
  const { user } = useUser();
  const url = `/users/project-role/${projectId}`;

  const { data, error, isLoading } = useQuery({
    queryKey: queryKeys.getUserProjectRole(projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!projectId,
    retry: !noRetry && !user?.isSiAdmin,
  });

  return {
    role: data?.role,
    error,
    isLoading,
  };
}
